import { getSiteKey } from "../firebaseConfig";
import { SiteCookie } from "../model/SiteModel";

export const GetCartCookieKey = `${SiteCookie.Cart}-${getSiteKey()}`;